import { IconDefinition } from "./types";

const chevronLeft: IconDefinition = {
  iconName: "chevron-left",
  width: 16,
  height: 16,
  svgPathData: "M11 2L6 7.978 11 14",
  iconType: "stroke",
};

export { chevronLeft };
